import script from "./PassthroughLogo.vue?vue&type=script&lang=js"
export * from "./PassthroughLogo.vue?vue&type=script&lang=js"

import exportComponent from "/Users/yllndritb/Projects/rent/rent-api/vendor/laravel/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__file',"PassthroughLogo.vue"]])

export default __exports__